'use client'

import {InstagramEmbed} from 'react-social-media-embed'

export type HgInstagramEmbedProps = {
  url: string
}

export const HgInstagramEmbed = ({url}: HgInstagramEmbedProps) => (
  <InstagramEmbed
    data-chromatic="ignore"
    captioned
    url={url}
    width="100%"
    height="100%"
  />
)
